import React from "react";

import "./HomePageNotifications.scss";

const HomePageNotifications = () => {
  return <div className='NotificationsContainer'>No available notifications to display</div>;
};

export default HomePageNotifications;
